<template>
  <div class="flex flex-column flex-1">
    <u-header :show-back="!editingMode" :prevent-back="!!selection" @back="$emit('back')">
      <span v-if="editingMode" slot="left" class="gift icon-cross" @click="cancel"></span>
      <span v-if="selection" @click="add"><span class="gift icon-plus">&nbsp;添加{{title}}</span></span>
      <span v-else>{{isMultiRemoving?'批量删除':title}}</span>
      <div slot="right" class="flex flex-1 flex-between">
        <span v-if="!selection&&!editingMode&&data.length" class="gift icon-multi" @click="multiRemove"></span>
        <span v-else>&nbsp;</span>
        <span v-if="selection||editingMode" class="gift icon-zhengque" @click="save"></span>
        <span v-else class="gift icon-plus" @click="add"></span>
      </div>
    </u-header>
    <div class="scrollable flex-1">
      <slot v-if="!data.length&&!isAdding"></slot>
      <div v-if="isAdding" class="row flex flex-column checked">
        <div class="left flex flex-1 flex-cross-center">
          <input class="editing-name" type="text" v-model="newName" ref="input">
        </div>
      </div>
      <div v-for="(item,index) in sortedList" :key="item.id" class="row flex flex-cross-center flex-between"
        :class="{checked:checkedList.indexOf(index)>-1}" @click="toggleChecked(index)"
        v-longpress="()=>{multiRemove();checkedList=[index]}">
        <div class="left flex-inline flex-cross-center">
          <span v-if="isMultiRemoving||selection" class="checkbox"></span>
          <input v-if="editingIndex === index" class="editing-name" type="text" v-model="newName" ref="input">
          <span v-else class="name">{{item.name}}</span>
        </div>
        <div v-if="!isMultiRemoving&&(editingIndex===-1||index!==editingIndex)" class="btn-list flex-inline flex-cross-center">
          <span class="gift icon-edit" @click="edit(item, index)"></span>
          <span class="gift icon-lajixiang" @click="remove(item, index)"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/utils'
export default {
  props: {
    title: String,
    data: {
      type: Array,
      validator (val) {
        return val.every(v => v.id != null)
      }
    },
    max: Number,
    duplicatable: {
      type: Boolean,
      default: false
    },
    localeSort: {
      type: Boolean,
      default: true
    },
    selection: Number
  },
  data () {
    return {
      editingIndex: -1,
      oldName: '',
      newName: '',
      isAdding: false,
      isMultiRemoving: false,
      checkedList: []
    }
  },
  computed: {
    sortedList () {
      if (this.localeSort) {
        return this.data.slice().sort((a, b) => a.name.localeCompare(b.name))
      }
      return data
    },
    editingMode () {
      return this.editingIndex > -1 || this.isMultiRemoving || this.isAdding
    }
  },
  methods: {
    focus () {
      this.$nextTick(() => {
        setTimeout(() => {
          if (isArray(this.$refs.input)) {
            this.$refs.input[0].focus()
          } else {
            this.$refs.input.focus()
          }
        }, 300)
      })
    },
    toggleChecked (index) {
      const _index = this.checkedList.indexOf(index)
      if (_index > -1) {
        this.checkedList.splice(_index, 1)
      } else {
        if (this.selection === 1) {
          this.checkedList = [index]
        } else {
          this.checkedList.push(index)
        }
      }
    },
    add () {
      if (this.max && this.data.length >= this.max) {
        this.$toast(`最多只能添加${this.max}条记录`)
        return
      }
      this.newName = ''
      this.isAdding = true
      this.focus()
    },
    cancel () {
      this.editingIndex = -1
      this.isAdding = false
      this.isMultiRemoving = false
      this.checkedList = []
    },
    edit(item, index) {
      this.oldName = item.name
      this.newName = item.name
      this.editingIndex = index
      this.focus()
    },
    remove (item, index) {
      this.$emit('remove', index)
    },
    save () {
      const name = this.newName.trim()
      if (!this.duplicatable && this.data.some((item, index) => this.editingIndex !== index && item.name === name)) {
        return this.$toast('已存在相同项')
      }
      if (this.isAdding) {
        this.$emit('add', name)
        this.cancel()
      } else if (this.isMultiRemoving) {
        this.$confirm(`确认要删除所选的${this.checkedList.length}项么？`).then(() => {
          this.$emit('remove', this.checkedList.slice())
          this.cancel()
        })
      } else if (this.selection) {
        this.$emit('select', this.checkedList.map(index => this.sortedList[index]))
      } else {
        if (!name) {
          return
        }
        // 未变更的不保存
        if (this.oldName !== name) {
          this.$emit('update', this.editingIndex, name)
        }
        this.cancel()
      }
    },
    multiRemove () {
      this.editingIndex = -1
      this.isMultiRemoving = true
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "./var.styl"
$cell-height = 48px
.row
  width 100%
  height $cell-height
  background-color #fff
  border-bottom 1px solid $color-text-disabled
  &.checked
    .left .checkbox
      border-color $color-primary
      &::before
       border-color transparent transparent $color-primary $color-primary
.left
  padding-left 10px
  .checkbox
    position relative
    display inline-block
    width 16px
    height @width
    line-height @height
    margin-right 10px
    font-size 12px
    text-align center
    border 1px solid $color-text-minor
    border-radius 50%
    &::before
      position absolute
      content ''
      left 2px
      top 4px
      width 10px
      height 5px
      border-style solid
      border-color transparent
      border-width 1px
      transform rotate3D(0, 0, 1, -45deg)
  .editing-name
    border none
    width 100%
    color $color-primary
.btn-list
  .gift
    display inline-block
    height $cell-height
    line-height @height
    padding 0 12px
    &:active
      background-color $color-primary
      color #fff
</style>



// WEBPACK FOOTER //
// ListManage.vue?22c91467